import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import api from '@/api';

// The one-time link from the admin: spend it for a preview session, then drop the
// token from the address bar.
export const Route = createFileRoute('/preview/$token')({
  component: RedeemPreview,
});

function RedeemPreview() {
  const { token } = Route.useParams();
  const navigate = useNavigate();
  // Set from the mutation's own callbacks: the request starts in an effect, and
  // StrictMode's remount detaches the hook's observer from it, so `isError` would
  // never arrive.
  const [failed, setFailed] = useState(false);
  const redeem = api.previewRedeem.useMutation(undefined, {
    onSuccess: () => navigate({ to: '/preview/', replace: true }),
    onError: () => setFailed(true),
  });
  // The link works once; StrictMode's second effect run mustn't spend it again.
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    redeem.mutate({ body: { token } });
  }, [redeem, token]);

  return (
    <Note>
      {/* Translation Needed */}
      {failed
        ? 'This preview link has already been used or has expired. Open a new preview from the admin.'
        : 'Opening preview…'}
    </Note>
  );
}

const Note = styled.p`
  color: var(--grey-700);
  font-size: 16px;
  padding: 60px 20px;
  text-align: center;
`;
